"use strict";require("@babel/runtime-corejs3/core-js-stable/object/define-property")(exports,"__esModule",{value:!0}),exports.jsObjectKeyRegExp=/^(([A-Za-z_$])((([A-Za-z_$])|(\d))*)$)|(\d+)$/;
